var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"grid-100 tablet-grid-100 container title"},[_c('h1',{staticClass:"title"},[_vm._v("Schedule Pickup")]),_vm._v(" "),_c('p',{staticClass:"sub-title sub-header"},[_vm._v(_vm._s(_vm.getSubMessage()))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7cecc1b7","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/schedulePickupHeader/schedulePickupHeader.vue
// module id = null
// module chunks = 